import React, { useState, useEffect } from "react";
import AuthHeader from "./AuthHeader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Steps, Input, Button, Row, Col, Card, Space } from "antd";

function SignUp(props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [signUpInfo, setSignUpInfo] = useState({ subscription_plans_xref: 1, promo_code_xref: 7 });
  const [signUpWaiting, setSignUpWaiting] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const nextStep = () => {
    if (!signUpInfo?.first_name || signUpInfo?.first_name?.length === 0) return props.MakeNotification("info", "Please enter your first name.");
    if (!signUpInfo?.last_name || signUpInfo?.last_name?.length === 0) return props.MakeNotification("info", "Please enter your last name.");
    if (!signUpInfo?.email || signUpInfo?.email?.search(/[a-zA-Z0-9_.\-+\[\]"']+@[a-zA-Z0-9_.\-+\[\]"']+[.][a-zA-Z0-9_.\-+\[\]"']+/) === -1)
      return props.MakeNotification("info", "Please enter a valid email.");
    if (!signUpInfo?.password || signUpInfo?.passwor < 8) return props.MakeNotification("info", "Your password must be at least 8 characters long.");
    if (!signUpInfo?.password || !signUpInfo?.password_confirm || signUpInfo?.password !== signUpInfo?.password_confirm) return props.MakeNotification("warning", "The passwords entered don't match.");
    setCurrentStep(currentStep + 1);
  };
  const previousStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const CompleteSignUp = async (event) => {
    if (!signUpInfo?.first_name || signUpInfo?.first_name?.length === 0) return props.MakeNotification("info", "Please enter your first name.");
    if (!signUpInfo?.last_name || signUpInfo?.last_name?.length === 0) return props.MakeNotification("info", "Please enter your last name.");
    if (!signUpInfo?.email || signUpInfo?.email?.search(/[a-zA-Z0-9_.\-+\[\]"']+@[a-zA-Z0-9_.\-+\[\]"']+[.][a-zA-Z0-9_.\-+\[\]"']+/) === -1)
      return props.MakeNotification("info", "Please enter a valid email.");
    if (!signUpInfo?.password || signUpInfo?.passwor < 8) return props.MakeNotification("info", "Your password must be at least 8 characters long.");
    if (!signUpInfo?.password || !signUpInfo?.password_confirm || signUpInfo?.password !== signUpInfo?.password_confirm) return props.MakeNotification("warning", "The passwords entered don't match.");
    if (!signUpInfo?.company_name || signUpInfo?.company_name?.length === 0) return props.MakeNotification("warning", "Please fill out the company name.");
    if (!signUpInfo?.phone_number || signUpInfo?.phone_number?.length < 3) return props.MakeNotification("warning", "Please enter the company phone number.");

    props.MakeNotification("success", "Signing up! One moment...");
    setSignUpWaiting(true);
    let response = await props.AxiosRequest("/api/user/sign-up", { ...signUpInfo });
    if (response.data.status === "success") navigate("/auth/login");
  };

  const CheckPromoCode = async (code = null) => {
    let response = await props.AxiosRequest("/api/subscription-promos/check", { code: code || signUpInfo.promo_code });
    if (response.data.status === "error") return props.MakeNotification("error", "Invalid Code");
    if (response.data.status === "invalid") return props.MakeNotification("error", "Invalid Code");
    if (response.data.status === "success") {
      props.MakeNotification("success", 'Promo  "' + (code || signUpInfo.promo_code) + '" Applied!', 3500, "topRight", true);
      setSignUpInfo({ ...signUpInfo, promo_code_xref: response.data.promo.id, promo_code: code || signUpInfo.promo_code });
    }
  };
  const steps = [
    {
      title: "First",
      content: (
        <Row gutter={[16, 8]} className="mx-4">
          <Col span={24}>
            <label className="col-form-label w-100">First Name *</label>
            <Input
              value={signUpInfo?.first_name}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, first_name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Last Name *</label>
            <Input
              value={signUpInfo?.last_name}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, last_name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Email *</label>
            <Input
              value={signUpInfo?.email}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, email: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Password *</label>
            <Input
              type="password"
              value={signUpInfo?.password}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, password: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Confirm Password *</label>
            <Input
              type="password"
              value={signUpInfo?.password_confirm}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, password_confirm: e.target.value });
              }}
            />
          </Col>
        </Row>
      ),
    },
    {
      title: "Second",
      content: (
        <Row gutter={[16, 8]} className="mx-4">
          <Col span={24}>
            <label className="col-form-label w-100">Company Name *</label>
            <Input
              value={signUpInfo?.company_name}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, company_name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Address Line 1 </label>
            <Input
              value={signUpInfo?.address_line_1}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, address_line_1: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Address Line 2 </label>
            <Input
              value={signUpInfo?.address_line_2}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, address_line_2: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">City</label>
            <Input
              value={signUpInfo?.city}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, city: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">State </label>
            <Input
              value={signUpInfo?.state}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, state: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Zip </label>
            <Input
              value={signUpInfo?.zip}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, zip: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Phone Number * </label>
            <Input
              value={signUpInfo?.phone_number}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, phone_number: e.target.value });
              }}
            />
          </Col>
          <Col span={12}></Col>
          <Col span={12}>
            <label className="col-form-label w-100">Promo Code </label>
            <Space.Compact>
              <Input
                value={signUpInfo?.promo_code}
                onChange={(e) => {
                  setSignUpInfo({ ...signUpInfo, promo_code: e.target.value.toUpperCase() });
                }}
              />
              <Button
                onClick={() => {
                  CheckPromoCode();
                }}
              >
                Apply
              </Button>
            </Space.Compact>
          </Col>
        </Row>
      ),
    },
  ];

  useEffect(() => {
    let code = searchParams?.get("promo")?.toUpperCase();
    if (code) {
      CheckPromoCode(code);
    }
  }, []);

  return (
    <div>
      <AuthHeader />
      <Row gutter={[16, 16]} className="mt-4">
        <Col span={8}></Col>
        <Col span={8}>
          <div className="text-center mt-4">
            <h1 className="h2">Sign Up</h1>
            <p className="lead">Get ready to bill more and work less</p>
          </div>
          <Card>
            <Row gutter={[16, 16]}>
              {/* <Steps
              // direction="vertical"
              current={currentStep}
              items={items}
            /> */}

              <Col span={24}>{steps[currentStep].content}</Col>

              <Col span={24} className="text-center mt-4">
                {currentStep > 0 && (
                  <Button
                    style={{
                      margin: "0 8px",
                    }}
                    onClick={() => previousStep()}
                  >
                    Previous
                  </Button>
                )}
                {currentStep < steps.length - 1 && (
                  <Button type="primary" onClick={() => nextStep()}>
                    Next
                  </Button>
                )}
                {currentStep === steps.length - 1 && (
                  <Button
                    type="primary"
                    onClick={() => {
                      CompleteSignUp();
                    }}
                  >
                    Sign Up
                  </Button>
                )}
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={8}></Col>
      </Row>

      {/* <main className="main h-100 w-100">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
              <div className="d-table-cell align-middle">
                <div className="text-center mt-4">
                  <h1 className="h2">Get started</h1>
                  <p className="lead">Start creating the best possible user experience for your firm.</p>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="m-sm-4">
                      <form onSubmit={this.handleSubmit}>
                        <div className="form-p1">
                          <div className="mb-3">
                            <label>First Name *</label>
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="name"
                              placeholder="Enter your first name"
                              onChange={(e) => this.setState({ first_name: e.target.value })}
                            />
                          </div>
                          <div className="mb-3">
                            <label>Last Name *</label>
                            <input className="form-control form-control-lg" type="text" name="name" placeholder="Enter your last name" onChange={(e) => this.setState({ last_name: e.target.value })} />
                          </div>
                          <div className="mb-3">
                            <label>Email *</label>
                            <input className="form-control form-control-lg" type="email" name="email" placeholder="Enter your email" onChange={(e) => this.setState({ email: e.target.value })} />
                          </div>
                          <div className="mb-3">
                            <label>Password *</label>
                            <input
                              className="form-control form-control-lg"
                              type="password"
                              name="password"
                              placeholder="Enter password"
                              onChange={(e) => this.setState({ password: e.target.value })}
                            />
                          </div>
                          <div className="mb-3">
                            <label>Confirm Password *</label>
                            <input
                              className="form-control form-control-lg"
                              type="password"
                              name="password"
                              placeholder="Confirm password"
                              onChange={(e) => this.setState({ password_confirm: e.target.value })}
                            />
                          </div>
                          <div className="text-center mt-3">
                            <button type="button" className="btn btn-lg btn-info" onClick={this.ConfirmUserInfo}>
                              Next
                            </button>
                          </div>
                        </div>
                        <div className="form-p2" style={{ display: "none" }}>
                          <div className="mb-3">
                            <label>Company Name *</label>
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="company"
                              placeholder="Enter your company name"
                              onChange={(e) => this.setState({ company_name: e.target.value })}
                            />
                          </div>
                          <div className="mb-3">
                            <label>Address Line 1</label>
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="company"
                              placeholder="Enter your company address"
                              onChange={(e) => this.setState({ company_address_line_1: e.target.value })}
                            />
                          </div>
                          <div className="mb-3">
                            <label>Address Line 2</label>
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="company"
                              placeholder="Enter your company address"
                              onChange={(e) => this.setState({ company_address_line_2: e.target.value })}
                            />
                          </div>
                          <div className="mb-3">
                            <label>City</label>
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="company"
                              placeholder="Enter your company city"
                              onChange={(e) => this.setState({ company_city: e.target.value })}
                            />
                          </div>
                          <div className="mb-3">
                            <label>State</label>
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="company"
                              placeholder="Enter your company state"
                              onChange={(e) => this.setState({ company_state: e.target.value })}
                            />
                          </div>
                          <div className="mb-3">
                            <label>Zip</label>
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="company"
                              placeholder="Enter your company zip"
                              onChange={(e) => this.setState({ company_zip: e.target.value })}
                            />
                          </div>
                          <div className="mb-3">
                            <label>Phone Number *</label>
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="company"
                              placeholder="Enter your company Phone Number"
                              onChange={(e) => this.setState({ company_telephone: e.target.value })}
                            />
                          </div>

                          <div className="row mb-3">
                            <div className="col-md-6">
                              <label>&nbsp;</label>
                            </div>
                            <div className="col-md-4">
                              <label className="mb-1">Promo code</label>
                              <input
                                className="form-control"
                                type="text"
                                name="name"
                                placeholder="Enter code here"
                                value={this.state.promo_code}
                                onChange={(e) => this.setState({ promo_code: e.target.value.toUpperCase() })}
                              />
                              <span className="text-center">
                                <label className="m-1">
                                  <b>{this.state.promo_message}</b>
                                </label>
                              </span>
                            </div>

                            <div className="col-md-2">
                              <label className="mb-1">&nbsp;</label>
                              <button type="button" className="btn btn-secondary" onClick={this.CheckPromoCode}>
                                Apply
                              </button>
                            </div>
                          </div>
                          <div className="text-center mt-3">
                            <button type="button" className="btn btn-lg btn-alert btn-light m-2" onClick={this.GoBackToUserInfo}>
                              Back
                            </button>
                            <button type="submit" disabled={this.state.is_submit_disabled} className="btn btn-lg btn-alert btn-info m-2">
                              Sign Up
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main> */}
    </div>
  );
}

// export class SignUpOld extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       is_submit_disabled: false,
//       email: "",
//       password: "",
//       password_confirm: "",
//       first_name: "",
//       last_name: "",
//       company_name: "",
//       company_address_line_1: "",
//       company_address_line_2: "",
//       company_city: "",
//       company_state: "",
//       company_zip: "",
//       company_telephone: "",
//       company_website: "",
//       company_fax: "",
//       selected_plan: 1,
//       promo_applied: 7,
//       promo_code: "",
//       promo_message: "",
//       promo: {},
//       number_of_users: "",
//       plans: [],
//       user_count_warning_message: "",

//       forte: {
//         api_login_id: "",
//         card_number: "",
//         expire_year: "",
//         expire_month: "",
//         cvv: "",
//         account_number: "",
//         routing_number: "",
//         account_type: "",
//       },
//     };
//   }
//   componentDidMount() {
//     this.GetPlans();
//     console.log(props.match);
//     if (props.match && props.match.params && props.match.params.promo) {
//       this.setState({ promo_code: props.match.params.promo }, () => {
//         this.CheckPromoCode();
//         console.log(this.state.promo_code);
//       });
//     }
//   }
//   handleSubmit = (event) => {
//     const topThis = this;
//     if ($(".form-p1").is(":visible")) {
//       this.ConfirmUserInfo();
//     } else if (this.state.first_name.length === 0) {
//       props.MakeNotification("info", "Please enter your first name.");
//     } else if (this.state.last_name.length === 0) {
//       props.MakeNotification("info", "Please enter your last name.");
//       // eslint-disable-next-line no-useless-escape
//     } else if (this.state.email.search(/[a-zA-Z0-9_.\-+\[\]"']+@[a-zA-Z0-9_.\-+\[\]"']+[.][a-zA-Z0-9_.\-+\[\]"']+/) === -1) {
//       //Email regex /[a-zA-Z0-9_.\-+\[\]"']+@[a-zA-Z0-9_.\-+\[\]"']+[.][a-zA-Z0-9_.\-+\[\]"']+/
//       props.MakeNotification("info", "Please enter a valid email.");
//     } else if (this.state.password.length < 8) {
//       props.MakeNotification("info", "Your password must be at least 8 characters long.");
//     } else if (this.state.password !== this.state.password_confirm) {
//       props.MakeNotification("warning", "The passwords entered don't match.");
//     } else if (this.state.company_name.length === 0) {
//       props.MakeNotification("warning", "Please fill out the company name.");
//       // @ZACHFUTURE } else if (this.state.selected_plan === "") {
//       //   props.MakeNotification("warning", "Please select a plan.");
//       // } else if (this.state.number_of_users === "") {
//       //   props.MakeNotification("warning", "Please input the expected amount of users.");
//       // } else if (
//       //   this.state.forte.card_number === "" ||
//       //   isNaN(this.state.forte.card_number.slice(-1)) ||
//       //   !this.state.forte.expire_month ||
//       //   !this.state.forte.expire_year ||
//       //   isNaN(this.state.forte.cvv.slice(-1)) ||
//       //   this.state.forte.cvv === ""
//       // ) {
//       //   props.MakeNotification("warning", "Please fill out all credit card information.");
//     } else if (this.state.company_telephone.length < 3) {
//       props.MakeNotification("warning", "Please enter the company phone number.");
//     } else {
//       topprops.MakeNotification("success", "Signing up! One moment...");
//       topThis.setState({ is_submit_disabled: true });
//       event.preventDefault();
//       let dataObj = {
//         email: this.state.email,
//         password: this.state.password,
//         password_confirm: this.state.password_confirm,
//         first_name: this.state.first_name,
//         last_name: this.state.last_name,
//         company_name: this.state.company_name,
//         company_address_line_1: this.state.company_address_line_1,
//         company_address_line_2: this.state.company_address_line_2,
//         company_city: this.state.company_city,
//         company_state: this.state.company_state,
//         company_zip: this.state.company_zip,
//         company_telephone: this.state.company_telephone,
//         forte: this.state.forte,
//         subscription_plan: this.state.selected_plan,
//         subscription_promo: this.state.promo_applied,
//       };
//       Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/user/sign-up", dataObj)
//         .then(function (response) {
//           // handle success
//           if (response["data"]["status"] === "Error") {
//             topThis.setState({ is_submit_disabled: false });
//             topprops.MakeNotification("error", response["data"]["message"] || "Error Signing Up. Please check the fields and try again.");
//           }
//           if (response["data"]["status"] === "success") {
//             topprops.MakeNotification("success", response["data"]["message"] || "Sign-up successful! Redirecting...");
//             setTimeout(function () {
//               window.location.href = window.location.protocol + "//" + window.location.host + "/auth/login";
//             }, 3000);
//           }
//           console.log(response);
//         })
//         .catch(function (error) {
//           //handle errors
//           topThis.setState({ is_submit_disabled: false });
//           topprops.MakeNotification("error", "There was an error during sign-up. Please check your inputs and try again.");
//         })
//         .then(function () {
//           // always executed
//         });
//     }
//     event.preventDefault();
//   };
//   GetPlans = () => {
//     const topThis = this;
//     Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/subscription-plans/get")
//       .then(function (response) {
//         // handle success
//         if (response["data"]["status"] === "Error") {
//           topprops.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
//         }
//         if (response["data"]["status"] === "success") {
//           topThis.setState({
//             plans: response["data"]["data"],
//           });
//         }
//         //console.log(response);
//       })
//       .catch(function (error) {
//         //handle errors
//         console.log(error);
//         if (error.response && error.response.status === 401) {
//           topprops.setRelogRequired(true);
//         }
//         topprops.MakeNotification("error", "There was an error. Please try again.");
//       })
//       .then(function () {});
//   };
//   CheckPromoCode = () => {
//     const topThis = this;
//     Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/subscription-promos/check", { code: this.state.promo_code })
//       .then(function (response) {
//         // handle success
//         if (response["data"]["status"] === "Error") {
//           topprops.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
//         }
//         if (response["data"]["status"] === "Invalid") {
//           topThis.setState({ promo_message: "Invalid Code" });
//         }
//         if (response["data"]["status"] === "success") {
//           topThis.setState({ promo_message: "Code Applied!", promo_applied: response.data.data.id, promo: { ...response["data"]["data"] } });
//         }
//       })
//       .catch(function (error) {
//         //handle errors
//         console.log(error);
//         if (error.response && error.response.status === 401) {
//           topprops.setRelogRequired(true);
//         }
//         topprops.MakeNotification("error", "There was an error. Please try again.");
//       })
//       .then(function () {});
//   };
//   ConfirmUserInfo = (event) => {
//     //check all inputs so far are valid
//     //move next
//     if (this.state.email.length === 0 || this.state.password.length === 0 || this.state.password_confirm.length === 0 || this.state.first_name.length === 0 || this.state.last_name.length === 0) {
//       props.MakeNotification("info", "Please fill out all fields.");
//       // eslint-disable-next-line no-useless-escape
//     } else if (this.state.email.search(/[a-zA-Z0-9_.\-+\[\]"']+@[a-zA-Z0-9_.\-+\[\]"']+[.][a-zA-Z0-9_.\-+\[\]"']+/) === -1) {
//       //Email regex /[a-zA-Z0-9_.\-+\[\]"']+@[a-zA-Z0-9_.\-+\[\]"']+[.][a-zA-Z0-9_.\-+\[\]"']+/
//       props.MakeNotification("info", "Please enter a valid email.");
//     } else if (this.state.password.length < 8) {
//       props.MakeNotification("info", "Your password must be at least 8 characters long.");
//     } else if (this.state.password !== this.state.password_confirm) {
//       props.MakeNotification("error", "The passwords entered don't match.");
//     } else {
//       $(".form-p1").hide(500);
//       $(".form-p2").show(500);
//     }
//   };
//   GoBackToUserInfo = (event) => {
//     //cycle to previous
//     $(".form-p2").hide(500);
//     $(".form-p1").show(500);
//   };
//   ConfirmCompanyInfo = (e) => {
//     if (this.state.company_name.length === 0) {
//       props.MakeNotification("warning", "Please fill out the company name.");
//       return;
//     }
//     $(".form-p2").hide(500);
//     $(".form-p3").show(500);
//   };
//   GoBackToCompanyInfo = (e) => {
//     $(".form-p3").hide(500);
//     $(".form-p2").show(500);
//   };
//   GetPriceToday = () => {
//     let full_price =
//       this.state.plans.find((l) => {
//         return l.id === this.state.selected_plan;
//       }).price_initial_user +
//       (this.state.number_of_users - 1) *
//         this.state.plans.find((l) => {
//           return l.id === this.state.selected_plan;
//         }).price_additional_users;
//     if (this.state.promo.discount_amount) {
//       let promo_price = full_price - this.state.promo.discount_amount;
//       return promo_price;
//     }
//     if (this.state.promo.discount_percent) {
//       let promo_price = full_price - full_price * (Number(this.state.promo.discount_percent) / 100);
//       console.log(promo_price);
//       return promo_price;
//     }
//     return full_price;
//   };
//   render() {
//     return (
//       <div>
//         <AuthHeader />
//         <main className="main h-100 w-100">
//           <div className="container h-100">
//             <div className="row h-100">
//               <div className="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
//                 <div className="d-table-cell align-middle">
//                   <div className="text-center mt-4">
//                     <h1 className="h2">Get started</h1>
//                     <p className="lead">Start creating the best possible user experience for your firm.</p>
//                   </div>
//                   <div className="card">
//                     <div className="card-body">
//                       <div className="m-sm-4">
//                         <form onSubmit={this.handleSubmit}>
//                           <div className="form-p1">
//                             <div className="mb-3">
//                               <label>First Name *</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="text"
//                                 name="name"
//                                 placeholder="Enter your first name"
//                                 onChange={(e) => this.setState({ first_name: e.target.value })}
//                               />
//                             </div>
//                             <div className="mb-3">
//                               <label>Last Name *</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="text"
//                                 name="name"
//                                 placeholder="Enter your last name"
//                                 onChange={(e) => this.setState({ last_name: e.target.value })}
//                               />
//                             </div>
//                             <div className="mb-3">
//                               <label>Email *</label>
//                               <input className="form-control form-control-lg" type="email" name="email" placeholder="Enter your email" onChange={(e) => this.setState({ email: e.target.value })} />
//                             </div>
//                             <div className="mb-3">
//                               <label>Password *</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="password"
//                                 name="password"
//                                 placeholder="Enter password"
//                                 onChange={(e) => this.setState({ password: e.target.value })}
//                               />
//                             </div>
//                             <div className="mb-3">
//                               <label>Confirm Password *</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="password"
//                                 name="password"
//                                 placeholder="Confirm password"
//                                 onChange={(e) => this.setState({ password_confirm: e.target.value })}
//                               />
//                             </div>
//                             <div className="text-center mt-3">
//                               <button type="button" className="btn btn-lg btn-info" onClick={this.ConfirmUserInfo}>
//                                 Next
//                               </button>
//                             </div>
//                           </div>
//                           <div className="form-p2" style={{ display: "none" }}>
//                             <div className="mb-3">
//                               <label>Company Name *</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="text"
//                                 name="company"
//                                 placeholder="Enter your company name"
//                                 onChange={(e) => this.setState({ company_name: e.target.value })}
//                               />
//                             </div>
//                             <div className="mb-3">
//                               <label>Address Line 1</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="text"
//                                 name="company"
//                                 placeholder="Enter your company address"
//                                 onChange={(e) => this.setState({ company_address_line_1: e.target.value })}
//                               />
//                             </div>
//                             <div className="mb-3">
//                               <label>Address Line 2</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="text"
//                                 name="company"
//                                 placeholder="Enter your company address"
//                                 onChange={(e) => this.setState({ company_address_line_2: e.target.value })}
//                               />
//                             </div>
//                             <div className="mb-3">
//                               <label>City</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="text"
//                                 name="company"
//                                 placeholder="Enter your company city"
//                                 onChange={(e) => this.setState({ company_city: e.target.value })}
//                               />
//                             </div>
//                             <div className="mb-3">
//                               <label>State</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="text"
//                                 name="company"
//                                 placeholder="Enter your company state"
//                                 onChange={(e) => this.setState({ company_state: e.target.value })}
//                               />
//                             </div>
//                             <div className="mb-3">
//                               <label>Zip</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="text"
//                                 name="company"
//                                 placeholder="Enter your company zip"
//                                 onChange={(e) => this.setState({ company_zip: e.target.value })}
//                               />
//                             </div>
//                             <div className="mb-3">
//                               <label>Phone Number *</label>
//                               <input
//                                 className="form-control form-control-lg"
//                                 type="text"
//                                 name="company"
//                                 placeholder="Enter your company Phone Number"
//                                 onChange={(e) => this.setState({ company_telephone: e.target.value })}
//                               />
//                             </div>

//                             <div className="row mb-3">
//                               <div className="col-md-6">
//                                 <label>&nbsp;</label>
//                               </div>
//                               <div className="col-md-4">
//                                 <label className="mb-1">Promo code</label>
//                                 <input
//                                   className="form-control"
//                                   type="text"
//                                   name="name"
//                                   placeholder="Enter code here"
//                                   value={this.state.promo_code}
//                                   onChange={(e) => this.setState({ promo_code: e.target.value.toUpperCase() })}
//                                 />
//                                 <span className="text-center">
//                                   <label className="m-1">
//                                     <b>{this.state.promo_message}</b>
//                                   </label>
//                                 </span>
//                               </div>

//                               <div className="col-md-2">
//                                 <label className="mb-1">&nbsp;</label>
//                                 <button type="button" className="btn btn-secondary" onClick={this.CheckPromoCode}>
//                                   Apply
//                                 </button>
//                               </div>
//                             </div>
//                             <div className="text-center mt-3">
//                               <button type="button" className="btn btn-lg btn-alert btn-light m-2" onClick={this.GoBackToUserInfo}>
//                                 Back
//                               </button>
//                               <button type="submit" disabled={this.state.is_submit_disabled} className="btn btn-lg btn-alert btn-info m-2">
//                                 Sign Up
//                               </button>
//                               {/* @ZACHFUTURE <button type="button" className="btn btn-lg btn-alert btn-info m-2" onClick={this.ConfirmCompanyInfo}>
//                                 Next
//                               </button> */}
//                             </div>
//                           </div>
//                           {/* @ZACHFUTURE <div className="form-p3">
//                             <div className="row mb-3">
//                               <div className="col-md-6 text-center">
//                                 <label className="m-1">Select Your Plan</label>
//                                 <ReactSelect
//                                   inputId="plan"
//                                   options={this.state.plans.map((e) => {
//                                     return { label: e.name, value: e.id };
//                                   })}
//                                   onChange={(e) => {
//                                     this.setState({ selected_plan: e.value });
//                                   }}
//                                 />
//                               </div>
//                               <div className="col-md-6">
//                                 <label className="m-1">Expected Users</label>
//                                 <input
//                                   className="form-control form-control-lg"
//                                   type="text"
//                                   name="name"
//                                   placeholder="User Count"
//                                   value={this.state.number_of_users}
//                                   onChange={(e) => {
//                                     let v = Number(e.target.value);
//                                     if (typeof v === "number" && v >= 0) {
//                                       this.setState({ number_of_users: Number(e.target.value) });
//                                     }
//                                   }}
//                                 />
//                               </div>
//                             </div>
//                             <div className="row mb-3">
//                               {this.state.number_of_users && this.state.selected_plan ? (
//                                 <div className="col-md-6 offset-md-3 text-center">
//                                   <label className="m-1">Price Today</label>
//                                   <h3>${this.GetPriceToday()}</h3>
//                                 </div>
//                               ) : null}
//                             </div>
//                             <hr></hr>
//                             <div className="row mb-3">
//                               <div className="col-md-12">
//                                 <label className="m-1">Credit Card Number</label>
//                                 <NumberFormat
//                                   className="form-control form-control-lg"
//                                   format="#### #### #### ####"
//                                   mask="-"
//                                   placeholder="1234-1234-1234-1234"
//                                   value={this.state.forte.card_number}
//                                   onChange={(e) => {
//                                     this.setState((prevState) => {
//                                       return { ...prevState, forte: { ...prevState.forte, card_number: e.target.value } };
//                                     });
//                                   }}
//                                 />
//                               </div>
//                             </div>
//                             <div className="row mb-3">
//                               <div className="col-md-4">
//                                 <label className="m-1">Expiration</label>
//                                 <ReactSelect
//                                   options={[
//                                     { label: "Jan - 01", value: 1 },
//                                     { label: "Feb - 02", value: 2 },
//                                     { label: "Mar - 03", value: 3 },
//                                     { label: "Apr - 04", value: 4 },
//                                     { label: "May - 05", value: 5 },
//                                     { label: "Jun - 06", value: 6 },
//                                     { label: "Jul - 07", value: 7 },
//                                     { label: "Aug - 08", value: 8 },
//                                     { label: "Sep - 09", value: 9 },
//                                     { label: "Oct - 10", value: 10 },
//                                     { label: "Nov - 11", value: 11 },
//                                     { label: "Dec - 12", value: 12 },
//                                   ]}
//                                   placeholder={"Month"}
//                                   onChange={(e) => {
//                                     this.setState((prevState) => {
//                                       return { ...prevState, forte: { ...prevState.forte, expire_month: e.value } };
//                                     });
//                                   }}
//                                 />
//                               </div>
//                               <div className="col-md-4">
//                                 <label className="m-1 invisible">Expiration Year</label>
//                                 <ReactSelect
//                                   options={[...Array(20).keys()]
//                                     .map((e) => {
//                                       let year = moment().year();
//                                       return year + e;
//                                     })
//                                     .map((e) => {
//                                       return { label: e, value: e };
//                                     })}
//                                   placeholder="Year"
//                                   onChange={(e) => {
//                                     this.setState((prevState) => {
//                                       return { ...prevState, forte: { ...prevState.forte, expire_year: e.value } };
//                                     });
//                                   }}
//                                 />
//                               </div>
//                               <div className="col-md-4">
//                                 <label className="m-1">CVV</label>
//                                 <NumberFormat
//                                   className="form-control form-control-lg"
//                                   format="###"
//                                   mask="-"
//                                   placeholder="123"
//                                   value={this.state.forte.cvv}
//                                   onChange={(e) => {
//                                     this.setState((prevState) => {
//                                       return { ...prevState, forte: { ...prevState.forte, cvv: e.target.value } };
//                                     });
//                                   }}
//                                 />
//                               </div>
//                             </div>
//                             <hr></hr>
//                             <br></br>
//                             <div className="row mb-3">
//                               <div className="col-md-6">
//                                 <label>&nbsp;</label>
//                               </div>
//                               <div className="col-md-4">
//                                 <label className="mb-1">Promo code</label>
//                                 <input
//                                   className="form-control"
//                                   type="text"
//                                   name="name"
//                                   placeholder="Enter code here"
//                                   value={this.state.promo_code}
//                                   onChange={(e) => this.setState({ promo_code: e.target.value.toUpperCase() })}
//                                 />
//                                 <span className="text-center ">
//                                   <label className="m-1">{this.state.promo_message}</label>
//                                 </span>
//                               </div>

//                               <div className="col-md-2">
//                                 <label className="mb-1">&nbsp;</label>
//                                 <button type="button" className="btn btn-secondary" onClick={this.CheckPromoCode}>
//                                   Apply
//                                 </button>
//                               </div>
//                             </div>
//                             <div className="text-center mt-3">
//                               <button type="button" className="btn btn-lg btn-alert btn-light m-2" onClick={this.GoBackToCompanyInfo}>
//                                 Prev
//                               </button>
//                               <button className="btn btn-lg btn-info m-2">Sign up</button>
//                             </div>
//                           </div> */}
//                         </form>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </main>
//       </div>
//     );
//   }
// }

export default SignUp;
